// Which word of a line is the cloze, shared by the lyric view and the add-to-
// collection form so the blank you saw while listening is the blank you get
// when you save it.

// Deterministic per line, so the blank doesn't move when the component
// re-renders 60 times a second. The longest word is the one worth recalling,
// and ties break on the earlier word.
export function clozeIndexFor(line) {
  if (!line.words || line.words.length < 3) return -1;

  let best = 0;
  line.words.forEach((word, index) => {
    if (word.text.length > line.words[best].text.length) best = index;
  });

  return best;
}

// The line with its cloze word wrapped the way the rest of the app writes them.
//
// Matching against line.text rather than rebuilding from the word list, because
// the word list comes from the sung timestamps and has no punctuation - joining
// it back up would quietly strip every comma in the lyric.
export function clozeTextFor(line) {
  const index = clozeIndexFor(line);
  if (index < 0) return line.text;

  const word = line.words[index].text;
  const at = line.text.indexOf(word);
  // The timestamps occasionally return a form that isn't in the written line at
  // all (an elision, a different spelling). Leaving it unwrapped is better than
  // wrapping the wrong span - and the field is editable anyway.
  if (at < 0) return line.text;

  return `${line.text.slice(0, at)}{{${word}}}${line.text.slice(at + word.length)}`;
}
